import { IconProps } from "./";
import Icon from "./assets/airplane_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Airplane(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
